import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import MuiTypography from '@mui/material/Typography';
import { Alert, Box, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import operatorService from '../../services/operatorService';
import { useSelector } from 'react-redux';

export const ClockHeader = ({ showLabels, title, subtitle, showButton, buttonAction }) => {
    const [now, setNow] = useState(dayjs());
    const [pendingStatus, setPendingStatus] = useState(null);
    const theme = useTheme();
    const customization = useSelector((state) => state.customization);

    const isAuthenticated = customization.autenticated;
    const userRole = customization.userData?.roles?.[0]?.systemName;

    useEffect(() => {
        const interval = setInterval(() => {
            setNow(dayjs());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (isAuthenticated && userRole === 'OPERATOR') {
            operatorService.checkPendingPreviousHour().then((res) => setPendingStatus(res));
        }
    }, []);

    useEffect(() => {
        if (isAuthenticated && userRole === 'OPERATOR') {
            const interval = setInterval(() => {
                operatorService.checkPendingPreviousHour().then((res) => setPendingStatus(res));
            }, 120000);

            return () => clearInterval(interval);
        }
    }, []);

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: showLabels || showButton ? 'space-between' : 'right',
                alignItems: 'center',
                width: '100%',
                px: 1 // margen lateral opcional,
            }}
        >
            {/* LADO IZQUIERDO */}
            {showLabels === true && (
                <Box sx={{ textAlign: 'left' }}>
                    <MuiTypography
                        variant="h2"
                        sx={{
                            fontWeight: 800,
                            color: theme.palette.primary.main
                        }}
                    >
                        {title}
                    </MuiTypography>

                    <MuiTypography variant="subtitle1" sx={{ color: theme.palette.primary.main }}>
                        {subtitle}
                    </MuiTypography>
                </Box>
            )}

            {showButton === true && (
                <Box sx={{ alignItems: 'left' }}>
                    <Button
                        key={-1}
                        onClick={buttonAction}
                        startIcon={<ArrowBackIcon sx={{ fontSize: 50 }} />}
                        variant="contained"
                        sx={{
                            width: '100%',
                            borderRadius: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: 'clamp(24px, 3vw, 40px)',
                            height: 'clamp(40px, 7vw,80px)',
                            fontWeight: 500,
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.secondary.dark
                        }}
                    >
                        Regresar
                    </Button>
                </Box>
            )}

            {/* LADO DERECHO */}
            <Box sx={{ textAlign: 'right' }}>
                <MuiTypography
                    variant="h1"
                    sx={{
                        fontWeight: 300,
                        color: theme.palette.primary.main
                    }}
                >
                    {now.format('hh:mm A')}
                </MuiTypography>

                <MuiTypography variant="h6" sx={{ color: theme.palette.primary.main }}>
                    {now.locale('es').format('dddd, D [de] MMMM [de] YYYY')}
                </MuiTypography>

                {pendingStatus?.pending && (
                    <Alert
                        severity="warning"
                        variant="filled"
                        sx={{
                            position: 'absolute',
                            top: 170,
                            right: 15,
                            zIndex: 2,
                            animation: 'pulse 2s infinite'
                        }}
                    >
                        Falta registrar la producción de la hora {pendingStatus.hour.substring(11, 16)}
                    </Alert>
                )}
            </Box>
        </Box>
    );
};
